import { cva } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const spinner = cva('inline-block animate-spin rounded-full border-current', {
  variants: {
    size: {
      sm: 'size-4 border-2',
      md: 'size-6 border-3',
      lg: 'size-8 border-4',
    },
  },
  defaultVariants: { size: 'md' },
});

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Announced while content loads. Pass `null` when a parent already labels the wait. */
  label?: string | null;
}

export function Spinner({ size, className, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label ?? undefined}
      // The transparent top edge is what makes the rotation visible.
      className={cn(spinner({ size }), 'border-t-transparent text-action-primary', className)}
    />
  );
}
